export default __webpack_public_path__ + "static/media/eth_simple.12ca69a7.svg";